export default __webpack_public_path__ + "static/media/contact-us.5918fb96.jpg";